/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GeocodageResource } from '../models/GeocodageResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class GeocodageService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Autocompletion d'adresse
     * Propositions d'adresses pour le texte saisi (`address`), avec coordonnees. Sert aux champs d'adresse de l'application.
     * @param address
     * @returns GeocodageResource Array of `GeocodageResource`
     * @throws ApiError
     */
    public geocodageIndex(
        address: string,
    ): CancelablePromise<Array<GeocodageResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/geocodage',
            query: {
                'address': address,
            },
            errors: {
                422: `Erreur de validation`,
            },
        });
    }
}
